/* Connected women's products share a color row and use Dawn's product swap. */
(() => {
  if(window.eliaPdpColorsInstalled) return;
  window.eliaPdpColorsInstalled=true;
  let pending;
  document.addEventListener('click',async event=>{
    const link=event.target.closest('[data-elia-pdp-color]');
    const host=link?.closest('product-info.elia-women-pdp');
    if(!host || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    if(typeof host.handleSwapProduct!=='function') return;
    event.preventDefault();
    if(pending) return;
    const url=new URL(link.href,location.href);
    if(url.origin!==location.origin) return;
    const button=host.querySelector('[name="add"]'),wasDisabled=button?.disabled;
    const error=host.querySelector('.elia-pdp-color-error')||document.createElement('p');
    error.className='elia-pdp-color-error';error.setAttribute('role','alert');error.hidden=true;
    if(!error.isConnected)link.closest('fieldset').after(error);
    host.setAttribute('aria-busy','true');if(button)button.disabled=true;
    pending=new AbortController();
    const timeout=setTimeout(()=>pending?.abort(),15000);
    try{
      const response=await fetch(url.href,{signal:pending.signal});
      if(!response.ok)throw new Error('Color fetch failed');
      const html=new DOMParser().parseFromString(await response.text(),'text/html');
      if(!html.querySelector('main product-info.elia-women-pdp'))throw new Error('Missing women template');
      /* Keep the color row where it was on screen; without this, Chrome's scroll anchoring jumps to the footer when main is replaced. */
      const anchorTop=link.closest('fieldset')?.getBoundingClientRect().top;
      const root=document.documentElement;root.style.overflowAnchor='none';
      const keepPlace=()=>{
        const row=document.querySelector('main product-info.elia-women-pdp fieldset.elia-color-option');
        if(row&&anchorTop!=null)window.scrollBy(0,row.getBoundingClientRect().top-anchorTop);
      };
      host.postProcessHtmlCallbacks.push(newNode=>{
        const color=newNode.querySelector('.elia-color-option input:checked,.product-form__input--swatch input:checked');
        color?.focus({preventScroll:true});
        keepPlace();requestAnimationFrame(()=>{keepPlace();setTimeout(()=>{keepPlace();root.style.overflowAnchor='';},350);});
      });
      host.handleSwapProduct(url.pathname,true)(html);
    }catch{
      error.textContent='Boja nije učitana. Pokušaj ponovo.';error.hidden=false;
      link.focus({preventScroll:true});
    }finally{
      clearTimeout(timeout);pending=null;host.removeAttribute('aria-busy');
      if(button)button.disabled=wasDisabled;
    }
  });
})();
